/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PerformanceExport
 */
export interface PerformanceExport {
  /**
   *
   * @type {string}
   * @memberof PerformanceExport
   */
  fileName: string;
  /**
   *
   * @type {string}
   * @memberof PerformanceExport
   */
  contentType: string;
  /**
   *
   * @type {string}
   * @memberof PerformanceExport
   */
  base64Content: string;
}

/**
 * Check if a given object implements the PerformanceExport interface.
 */
export function instanceOfPerformanceExport(
  value: object,
): value is PerformanceExport {
  if (!("fileName" in value) || value["fileName"] === undefined) return false;
  if (!("contentType" in value) || value["contentType"] === undefined)
    return false;
  if (!("base64Content" in value) || value["base64Content"] === undefined)
    return false;
  return true;
}

export function PerformanceExportFromJSON(json: any): PerformanceExport {
  return PerformanceExportFromJSONTyped(json, false);
}

export function PerformanceExportFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceExport {
  if (json == null) {
    return json;
  }
  return {
    fileName: json["fileName"],
    contentType: json["contentType"],
    base64Content: json["base64Content"],
  };
}

export function PerformanceExportToJSON(json: any): PerformanceExport {
  return PerformanceExportToJSONTyped(json, false);
}

export function PerformanceExportToJSONTyped(
  value?: PerformanceExport | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fileName: value["fileName"],
    contentType: value["contentType"],
    base64Content: value["base64Content"],
  };
}
